export default __webpack_public_path__ + "static/media/soundicon_muted.8edb9167.webp";